<div class="page">

  <div class="pagehead">
    <div>
      <h1>Move to bank</h1>
      <p>Settle your wallet balance to your primary bank account</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Transfer mode">
        <button type="button" [class.on]="transactiontype === 'IMPS'" (click)="M2bMode({ value: 'IMPS' })">IMPS</button>
        <button type="button" [class.on]="transactiontype === 'NEFT'" (click)="M2bMode({ value: 'NEFT' })">NEFT</button>
      </div>
    </div>
  </div>

  <div class="notes" *ngIf="noteData">
    <div class="note-row" *ngFor="let i of noteData">
      <i class="fa fa-info-circle" aria-hidden="true"></i><label>{{ i.message }}</label>
    </div>
    <div class="note-row" *ngFor="let i of noteDataIMPS">
      <i class="fa fa-info-circle" aria-hidden="true"></i><label>{{ i.message }}</label>
    </div>
  </div>

  <div class="row-2-1">
    <div class="card">
      <div class="clabel"><svg viewBox="0 0 24 24"><path d="M3 12h14M13 6l6 6-6 6"/></svg>Transfer details · {{ transactiontype }}</div>
      <form [formGroup]="form" class="kit-form">
        <div class="er-field er-field--amount" [class.has-error]="isFieldInvalid('amount')">
          <label class="er-field__label" for="m2b-amount">Amount <span class="req">*</span></label>
          <div class="er-field__wrap">
            <span class="er-field__affix">₹</span>
            <input id="m2b-amount" class="er-field__control" type="number" formControlName="amount"
              placeholder="0" required>
          </div>
          <div class="er-field__help">Eligible amount {{ walletAmount | erInr }}</div>
          <div class="er-field__error" *ngIf="isFieldInvalid('amount')">Enter the amount</div>
        </div>

        <div class="er-field" [class.has-error]="isFieldInvalid('comments')">
          <label class="er-field__label" for="m2b-remark">Remark <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="m2b-remark" class="er-field__control" formControlName="comments"
              placeholder="Purpose of the settlement" required>
          </div>
          <div class="er-field__error" *ngIf="isFieldInvalid('comments')">Enter a remark</div>
        </div>

        <div class="form-actions">
          <button type="button" class="er-btn er-btn--primary" (click)="sendOTP(content);"
            *ngIf="!isValidOtp && !isSubmit">Move to bank</button>
        </div>
      </form>
    </div>

    <div class="card" *ngIf="dataSource">
      <div class="clabel"><svg viewBox="0 0 24 24"><path d="M3 10l9-6 9 6M5 10v9h14v-9M9 19v-5h6v5"/></svg>Primary bank account</div>
      <ng-container *ngFor="let i of dataSource">
        <div class="bank" *ngIf="i.isBankPrimary == 'True'">
          <div class="bank-row"><span class="bl">Account holder</span><span class="bv">{{ i.nameAtBank }}</span></div>
          <div class="bank-row"><span class="bl">Account number</span><span class="bv bv--mono">{{ i.accountNumber }}</span></div>
          <div class="bank-row"><span class="bl">Bank</span><span class="bv">{{ i.bankName }}</span></div>
          <div class="bank-row"><span class="bl">IFSC</span><span class="bv bv--mono">{{ i.bankIfscCode }}</span></div>
          <button type="button" class="er-btn er-btn--ghost change-bank" (click)="changeBank()">Change bank →</button>
        </div>
      </ng-container>
    </div>
  </div>

</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header er-modal-head">
    <h6 class="modal-title" id="modal-basic-title">OTP sent to {{ retailor_phoneNumber }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="otpform">
      <div class="er-field otp-field" [class.has-error]="isOtpFieldInvalid('otp')">
        <div class="er-field__wrap">
          <input class="er-field__control otp-input" type="text" placeholder="······"
            (keypress)="numberOnly($event)" minlength="6" maxlength="6" formControlName="otp" required>
        </div>
        <div class="er-field__error" *ngIf="isOtpFieldInvalid('otp')">Enter the 6-digit OTP</div>
      </div>
    </form>
    <countdown [config]="{leftTime:180}" *ngIf="!isResendEnable" (event)="handleEvent($event)">$!m!:$!s!</countdown>
  </div>
  <div class="modal-footer">
    <button (click)="resendOTP()" *ngIf="isResendEnable" class="er-btn er-btn--ghost">Resend</button>
    <button class="er-btn er-btn--primary" (click)="validateOTP(otpform.value,'content')">Submit</button>
  </div>
</ng-template>

<ng-template #serviceModal let-c="close" let-d="dismiss">
  <div class="modal-header er-modal-head">
    <h5 class="modal-title" id="modal-basic-title">Move to bank service unavailable</h5>
  </div>
  <div class="modal-body" style="text-align:center;">
    <img src="../../../assets/images/images/serviceUnavailable.png" style="width: 35%;">
    <h6>{{ serviceData.message }}</h6>
  </div>
  <div class="modal-footer">
    <button type="button" class="er-btn er-btn--primary" style="margin: auto;" *ngIf="serviceData.message != 'Invalid User Authentication. YM'" (click)="closeServiceModal(serviceModal)">Okay</button>
    <button type="button" class="er-btn er-btn--primary" style="margin: auto;" *ngIf="serviceData.message == 'Invalid User Authentication. YM'" (click)="closeServiceModalOut(serviceModal)">Okay</button>
  </div>
</ng-template>


